import React, { forwardRef, useRef } from 'react'
import {
  Cropper as DefaultCropper,
  CropperProps as DefaultCropperProps,
  CropperRef,
  ImageRestriction,
  mergeRefs,
  ScaleImageOptions,
} from 'react-advanced-cropper'
// eslint-disable-next-line import/no-extraneous-dependencies
import {
  defaultSize,
  fitStencilToImage,
  resizeCoordinates,
  stencilConstraints,
  transformImage,
  zoomStencil,
} from 'advanced-cropper/showcase/mobile'

export interface CropperProps
  extends Omit<
    DefaultCropperProps,
    | 'transitions'
    | 'priority'
    | 'imageRestriction'
    | 'stencilSize'
    | 'stencilConstraints'
    | 'transformImage'
  > {
  resizeImage?: boolean | Omit<ScaleImageOptions, 'adjustStencil'>
  imageRestriction?: ImageRestriction.none | ImageRestriction.stencil
}

export const Cropper = forwardRef((props: CropperProps, ref) => {
  const {
    className,
    stencilProps = {},
    wrapperComponent,
    imageRestriction = ImageRestriction.stencil,
    ...cropperProps
  } = props

  const cropperRef = useRef<CropperRef>(null)

  return (
    <DefaultCropper
      {...cropperProps}
      ref={mergeRefs([ref, cropperRef])}
      stencilConstraints={stencilConstraints}
      stencilProps={{
        grid: true,
        ...stencilProps,
        movable: false,
      }}
      // wrapperComponent={WrapperComponent}
      // wrapperProps={{
      //   navigationProps,
      //   navigation,
      //   spinnerClassName,
      // imageRestriction={ImageRestriction.none}
      className={className}
      defaultSize={defaultSize}
      transformImageAlgorithm={transformImage}
      transitions
      postProcess={
        imageRestriction === ImageRestriction.none
          ? zoomStencil
          : [fitStencilToImage, zoomStencil]
      }
      resizeCoordinatesAlgorithm={
        imageRestriction === ImageRestriction.none
          ? undefined
          : resizeCoordinates
      }
    />
  )
})

Cropper.defaultProps = {
  resizeImage: false,
  imageRestriction: ImageRestriction.stencil,
}
Cropper.displayName = 'Cropper'
